import { render, staticRenderFns } from "./DataLineage.vue?vue&type=template&id=83e64e02"
import script from "./DataLineage.vue?vue&type=script&lang=js"
export * from "./DataLineage.vue?vue&type=script&lang=js"
import style0 from "./DataLineage.vue?vue&type=style&index=0&id=83e64e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports